import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import "./DataFolder.css";
import Breadcrumb from "../Breadcrumb";
import useResizableTable from "../../hooks/useResizableTable";
// import useSortData from "../../hooks/useSortableTable";
import DocumentSearchBar from "../DocumentSearchBar/DocumentSearchBar";
import {
  COLUMN_WIDTH,
  COLUMN_STYLE,
  DEFAULT_COLUMN_WIDTH,
} from "../../constants/columnConfig";

const DataFolder = React.memo(
  ({
    user,
    count,
    keys,
    fetchDataCount,
    menuData = [],
    headers,
    data,
    fetchDataFolder,
    isFetching,
    isFetchingCount,

    searchData: searchResults,
    searchCount,
    fetchSearchData,
  }) => {
    console.log("DataFolder.jsx Rendered");

    const { deptId, folderId } = useParams();
    const [showUserName, setUserName] = useState("");
    const [tableData, setTableData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageGroup, setPageGroup] = useState(0);
    // const { sortConfig, handleSort, resetSort  } = useSortData();
    // const [hoveredColumn, setHoveredColumn] = useState(null);
    // const reloadFlag = useSelector((state) => state.menu.reloadFolderFlag);

    const [isSearchMode, setIsSearchMode] = useState(false);
    const [searchHeaders, setSearchHeaders] = useState([]);
    const [searchTitle, setSearchTitle] = useState("");
    const [searchTableData, setSearchTableData] = useState([]);

    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    console.log("DataFolder.jsx - deptId", deptId);
    console.log("DataFolder.jsx - folderId", folderId);

    //テーブル列リサイズ機能の設定
    useResizableTable([headers, folderId]);

    //初期表示・ユーザー情報設定
    useEffect(() => {
      if (user?.user_name) setUserName(user.user_name);
    }, [user]);

    useEffect(() => {
      if (deptId && !folderId) {
        setIsSearchMode(false);
        setSearchHeaders([]);
        setSearchTitle("");

        dispatch({ type: "CLEAR_DATA_FOLDER" });

        fetchDataFolder({ department_id: deptId });

        // resetSort();
        // setHoveredColumn(null);
      }
    // eslint-disable-next-line
    }, [deptId, folderId, location.state?.forceReload]);

    //フォルダ再読み込み処理
    useEffect(() => {
      if (!folderId) return;

      dispatch({ type: "CLEAR_DATA_FOLDER" });
      fetchDataCount(folderId);
      fetchDataFolder({ folder_id: folderId, department_id: deptId });

      setIsSearchMode(false);
      setSearchHeaders([]);
      setSearchTitle("");

      setCurrentPage(1);
      setPageGroup(0);

      // resetSort();
      // setHoveredColumn(null);

    // eslint-disable-next-line
    }, [folderId, deptId, location.state?.forceReload]);
   

    // Clear data on home
    useEffect(() => {
      if (location.pathname === "/") {
        dispatch({ type: "CLEAR_DATA_FOLDER" });
      }
      // eslint-disable-next-line
    }, [location.pathname]);

    // Update tableData on new folder data
    useEffect(() => {
      // if (!folderId) {
      //   setTableData([]);
      //   return;
      // }

      setTableData(data?.map((row) => ({ ...row, checked: false })) || []);
    }, [folderId, data]);

    useEffect(() => {
      if (isSearchMode && searchResults) {
        setSearchTableData(
          searchResults.map((r) => ({ ...r, checked: false }))
        );
      }
    }, [searchResults, isSearchMode]);

    // --- Pagination + Search paging ---
    const itemsPerPage = 100;
    const totalPages = isSearchMode
      ? Math.ceil((searchResults?.length || 0) / itemsPerPage)
      : Math.ceil(count / itemsPerPage);

    const pagedData = isSearchMode
      ? searchTableData.slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage
        )
      : tableData;

    const currentData = pagedData || [];

    //メニュー情報から部署名・フォルダ名を取得
    const currentHeaders = isSearchMode ? searchHeaders : headers;

    const currentDept = menuData.find((d) => d.department_id === deptId);
    const departmentName = currentDept?.department_name || "";

    const currentFolder = currentDept?.folder?.find(
      (f) => f.folder_id === folderId
    );
    const folderName = currentFolder?.folder_name || "";

    // Page change
    const handlePageChange = (page) => {
      setCurrentPage(page);

      if (!isSearchMode) {
        const key = keys?.[page - 1] ?? null;
        fetchDataFolder({
          folder_id: folderId,
          department_id: deptId,
          key,
        });
      }
    };

    // ソート処理
    // const onSortColumn = (key) => {
    //   // ---- SEARCH MODE ----
    //   if (isSearchMode) {
    //     if (!searchTableData || searchTableData.length === 0) return;

    //     const sorted = handleSort(key, searchTableData);
    //     setSearchTableData(sorted);
    //     return;
    //   }

    //   // ---- NORMAL MODE ----
    //   if (!tableData || tableData.length === 0) return;

    //   const sorted = handleSort(key, tableData);
    //   setTableData(sorted);
    // };

    // Search
    const handleSearch = (title, fixedHeaders) => {
      const keyword = title.trim();

      if (!keyword) {
        setIsSearchMode(false);
        setSearchHeaders([]);
        setSearchTitle("");
        setCurrentPage(1);
        setPageGroup(0);

        if (folderId) {
          fetchDataCount(folderId);
          fetchDataFolder({
            folder_id: folderId,
            department_id: deptId,
          });
        } else {
          fetchDataFolder({
            department_id: deptId,
            header_flag: 1,
            folder_id: null,
          });
        }

        return;
      }

      setIsSearchMode(true);
      setSearchHeaders(fixedHeaders);
      setSearchTitle(keyword);
      setCurrentPage(1);
      setPageGroup(0);

      fetchSearchData(keyword);
    };

    // Navigation
    const handleRegisterClick = () => {
      navigate(`/department/${deptId}/folder/${folderId}/register`);
    };

    const handleDetailSearchClick = () => {
      if (folderId) {
        navigate(`/department/${deptId}/folder/${folderId}/detailsearch`);
      } else {
        navigate(`/department/${deptId}/detailsearch`);
      }
    };

    // ウエンタオ追加ー文書参照画面処理-Start
    const handleDocumentView = (row) => {
      if (!row?.doc_id) return;
      window.open(`/viewId/${row.doc_id}/view`);
    };
    // ウエンタオ追加ー文書参照画面処理-End

    return (
      <div id="Main">
        <div id="Contents">
          <Breadcrumb
            userName={showUserName}
            departmentName={departmentName}
            folderName={folderName}
            deptId={deptId}
          />

          <div className="document-header__container">
            {folderId && (
              <>
                <div className="document-button__container">
                  <div className="document-button__register">
                    <button
                      className="document-button__btn document-button__btn--register"
                      onClick={handleRegisterClick}
                    >
                      登録
                    </button>
                  </div>
                  <div className="document-button__search">
                    <button
                      className="document-button__btn document-button__btn--search"
                      onClick={handleDetailSearchClick}
                    >
                      検索
                    </button>
                  </div>
                </div>

                <DocumentSearchBar
                  value={searchTitle}
                  onChange={setSearchTitle}
                  onSearch={handleSearch}
                />
              </>
            )}
          </div>

          {folderId && (
            <div className="document-data__count">
              <span>件数：</span>

              {!isFetching && isFetchingCount ? (
                <span className="count-loading">
                  <span className="count-spinner"></span>
                </span>
              ) : (
                <span>{isSearchMode ? searchCount : count ?? 0}</span>
              )}
            </div>
          )}

          {/* ===============================
              画面タイトル（左上）
              =============================== */}
            {!folderId && (
              <div className="title">
                What’s New（部門の直近100件）
              </div>
            )}

          {/* TABLE */}
          <div className={isSearchMode ? "search-table__container" : "document-table__container"}>
            <table className={isSearchMode ? "search-table__table" : "document-table__table"}>
              <thead>
                <tr>
                  {(!currentHeaders || currentHeaders.length === 0) && (
                    <th></th>
                  )}
                  {currentHeaders
                    ?.sort((a, b) => a.display_idx - b.display_idx)
                    .map((col, idx) => {
                      // const isHovered = hoveredColumn === col.pattern_name;
                      // const isSorted = sortConfig.key === col.pattern_name;
                      // const currentDir = isSorted
                      //   ? sortConfig.direction
                      //   : "asc";

                      return (
                        <th
                          key={idx}
                          style={{
                            width: COLUMN_WIDTH[col.pattern_name] || DEFAULT_COLUMN_WIDTH,
                            ...(COLUMN_STYLE[col.pattern_name] || {}),
                          }}
                          // onClick={() => onSortColumn(col.pattern_name)}
                          // onMouseEnter={() =>
                          //   setHoveredColumn(col.pattern_name)
                          // }
                          // onMouseLeave={() => setHoveredColumn(null)}
                          // style={{ cursor: "pointer", userSelect: "none" }}
                        >
                          {col.pattern_text}
                          {/* {(isHovered || isSorted) && (
                            <span className="sort-icon">
                              {currentDir === "asc" ? "▲" : "▼"}
                            </span>
                          )} */}
                        </th>
                      );
                    })}
                </tr>
              </thead>

              <tbody>
                {currentData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {currentHeaders
                      ?.sort((a, b) => a.display_idx - b.display_idx)
                      .map((header, colIndex) => {
                        let value = "";

                        if (header.pattern_name === "issue_date") {
                          value = row.issue_datetime
                            ? row.issue_datetime.split(" ")[0]
                            : "";
                        } else if (header.pattern_name === "auto_number") {
                          const prefix = row.folder_edition
                            ? row.folder_edition + "-"
                            : "";
                          value = prefix + (row.auto_number || "");
                        } else {
                          value = row[header.pattern_name] ?? "";
                        }

                        return (
                          <td 
                            key={colIndex}                             
                            title={value}
                            style={{
                            width: COLUMN_WIDTH[header.pattern_name] || DEFAULT_COLUMN_WIDTH,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            ...(COLUMN_STYLE[header.pattern_name] || {}),
                          }}
                          >
                            {header.pattern_name === "title" ? (
                              <span
                                className="document-link"
                                style={{
                                  color: "#0091a7",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleDocumentView(row)}
                              >
                                {value}
                              </span>
                            ) : (
                              value
                            )}
                          </td>
                        );
                      })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* PAGINATION */}
          <div className="pagination-container">
            {totalPages > 0 && (
              <div className="pagination">
                {pageGroup > 0 && (
                  <button
                    onClick={() => setPageGroup((p) => p - 1)}
                    className="pagination-arrow"
                  >
                    &laquo;
                  </button>
                )}

                {Array.from(
                  { length: Math.min(10, totalPages - pageGroup * 10) },
                  (_, i) => {
                    const page = pageGroup * 10 + i + 1;
                    return (
                      <button
                        key={page}
                        className={`pagination-btn ${
                          page === currentPage ? "active" : ""
                        }`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    );
                  }
                )}

                {(pageGroup + 1) * 10 < totalPages && (
                  <button
                    onClick={() => setPageGroup((p) => p + 1)}
                    className="pagination-arrow"
                  >
                    &raquo;
                  </button>
                )}
              </div>
            )}
          </div>
        </div>

        <div className={`overlay ${(isFetching) ? "active" : ""}`}>
          <div className={`spinner ${(isFetching) ? "active" : ""}`}></div>
        </div>
      </div>
    );
  }
);

DataFolder.propTypes = {
  user: PropTypes.object,
  isFetching: PropTypes.bool.isRequired,
  isFetchingCount: PropTypes.bool.isRequired,
  count: PropTypes.number.isRequired,
  keys: PropTypes.array.isRequired,
  headers: PropTypes.array.isRequired,
  error: PropTypes.string,
  fetchDataCount: PropTypes.func.isRequired,
  fetchDataFolder: PropTypes.func.isRequired,
  fetchSearchData: PropTypes.func.isRequired,
};

export default DataFolder;
